// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["css/ckeditor5","css/arocom.style"], () => (__webpack_require__("./src/js/arocom.script.js")))
__webpack_require__.O(undefined, ["css/ckeditor5","css/arocom.style"], () => (__webpack_require__("./src/sass/arocom.style.scss")))
var __webpack_exports__ = __webpack_require__.O(undefined, ["css/ckeditor5","css/arocom.style"], () => (__webpack_require__("./src/sass/editor/ckeditor5.scss")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
